export default {
  errors: [],
  success: false,
  employees: [],
  next_employees_url: "owner/employee",
  search_keyword: "",
  search_station: undefined,
  shouldAppend: true,
};
